export default __webpack_public_path__ + "static/media/microcomputador.e7fb532d.png";